import fromUnixTime from 'date-fns/fromUnixTime';

import { API_URL } from '../env';

export const buildFileSrc = (hash: string) => `${API_URL}file/get/${hash}`;

export const fromUnixString = (stringDate: string) =>
  fromUnixTime(Number(stringDate));
